import React from 'react'
import { Box } from '@mui/material'
import PropTypes from 'prop-types'

function Section({ children }) {
  return (
    <Box
      sx={{
        py: {
          xs: 3,
          md: 5,
        },
      }}
    >
      {children}
    </Box>
  )
}

Section.propTypes = {
  children: PropTypes.node,
}
Section.defaultProps = {
  children: null,
}
export default Section
